import { render } from "./ModuleItem.vue?vue&type=template&id=a2ce2104&ts=true"
import script from "./ModuleItem.ts?vue&type=script&lang=ts"
export * from "./ModuleItem.ts?vue&type=script&lang=ts"

import "./ModuleItem.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__